import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
import { values } from 'lodash';
const FormItem = Form.Item;
const { Option } = Select;

class UrbioticaInfrastructureSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleTypeChange = e => {
    if (e == 'U-Spot') {
      this.setState({
        disabled: false
      });
    } else {
      this.setState({
        disabled: true
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSuccess(this.props.form, values);
        this.props.onModalCancel(this.props.form);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;
    const { disabled } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label='POM'>
          {getFieldDecorator('pom', {
            initialValue: this.props.initialValues && this.props.initialValues.pom
              ? this.props.initialValues.pom
              : null,
            rules: [{
              type: 'number', message: 'Položka musí být number!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label='ElementID'>
          {getFieldDecorator('elementID', {
            initialValue: this.props.initialValues && this.props.initialValues.elementID
              ? this.props.initialValues.elementID
              : null,
            rules: [{
              type: 'string', message: 'Položka musí být string!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Typ">
          {getFieldDecorator('productType', {
            initialValue: this.props.initialValues && this.props.initialValues.productType
              ? this.props.initialValues.productType
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!'
            }],
          })(
            <Select
              size="default"
              placeholder='Zvolte typ'
              onChange={this.handleTypeChange}
            >
              <Option value="U-Spot">U-Spot</Option>
              <Option value="U-Flow">U-Flow</Option>
              <Option value="U-Box">U-Box</Option>
            </Select>
          )}

        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID',
            {
              initialValue: this.props.initialValues && (this.props.initialValues.placeID || this.props.initialValues.placeID == 0)
                ? this.props.initialValues.placeID
                : null,
            })(
              <InputNumber min={0} max={999999} disabled={disabled} />
            )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Typ zprávy">
          {getFieldDecorator('messageType', {
            initialValue: this.props.initialValues && this.props.initialValues.messageType
              ? this.props.initialValues.messageType
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Select
              size="default"
              disabled={disabled}
            >
              <Option value="--">--</Option>
              <Option value="vehicle_ctrl">vehicle_ctrl</Option>
              <Option value="vehicle">vehicle</Option>
            </Select>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Upozornění" >
          {getFieldDecorator('reportsEnabled', {
            valuePropName: 'checked',
            initialValue: this.props.initialValues && this.props.initialValues.reportsEnabled
              ? this.props.initialValues.reportsEnabled
              : false,
            rules: [{
              required: true, message: 'Zadejte prosím tuto položku!',
            }],
          })(
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="close" />} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={700}
          title="Nastavení infrastruktury"
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          onOk={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedUrbioticaInfrastructureSettingsForm = Form.create()(UrbioticaInfrastructureSettingsForm);

export default WrappedUrbioticaInfrastructureSettingsForm;


// WEBPACK FOOTER //
// ./src/components/UrbioticaInfrastructureSettingsForm.js